import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  attachmentListLabel: {
    id: 'frontbucket.repository.pullrequest.attachmentListLabel',
    description: 'Label for a list of attachments for a pull request',
    defaultMessage: 'Attachments',
  },
  // This can represent:
  //  "0 attachments"
  //  "1 attachment"
  //  "{X} attachments"
  //  "Attachments" (if error)
  attachmentPanelHeader: {
    id: 'frontbucket.repository.pullrequest.attachmentPanelHeader',
    description: 'Header with number of attachments in a pull request',
    defaultMessage: `
      {hasError, select,
        true {Attachments}
        other {{count, plural,
          one {{count} attachment}
          other {{count} attachments}
        }}
      }`,
  },
  loadAttachmentsGenericError: {
    id: 'frontbucket.repository.pullrequest.loadAttachmentsGenericError',
    description:
      'Generic text explaining that we could not load the pull request attachments',
    defaultMessage: "Couldn't load attachments",
  },
  noAttachmentsLabel: {
    id: 'frontbucket.repository.pullrequest.noAttachmentsLabel',
    description: 'Generic text when there are no attachments uploaded',
    defaultMessage: "There aren't any attachments.",
  },
  openPopupBtn: {
    id: 'frontbucket.repository.pullrequest.attachments.openPicker.link',
    description: 'button link to open media-viewer to select attachments',
    defaultMessage: 'Browse to upload',
  },
  deleteButtonLabel: {
    id: 'frontbucket.repository.pullrequest.attachments.delete.action.label',
    description: 'label for attachment delete action',
    defaultMessage: 'Delete',
  },
  cancelButtonLabel: {
    id: 'frontbucket.repository.pullrequest.attachments.cancel.action.label',
    description: 'label for attachment cancel action',
    defaultMessage: 'Cancel',
  },
  deleteModalTitle: {
    id: 'frontbucket.repository.pullrequest.attachments.delete.modal.title',
    description: 'title for delete attachment modal',
    defaultMessage: 'Delete attachment',
  },
  deleteConfirmation: {
    id: 'frontbucket.repository.pullrequest.attachments.delete.action.confirm',
    description: 'confirmation message for delete action for attachments',
    defaultMessage: 'Are you sure you want to delete this attachment?',
  },
});
